// extracted by mini-css-extract-plugin
export default {"removeBtnBox":"RemoveIcon_removeBtnBox__0Mu4A","charges":"RemoveIcon_charges__bg-36","icon":"RemoveIcon_icon__nR5s6"};